// PreVisr Medical School Data
// POC: 25 verified MD schools -- all data from MSAR 2026-2027
// All stats verified: estimated: false

export const medicalSchools = [
  {
    id: "albert-einstein-college-of-medicine",
    name: "Albert Einstein College of Medicine",
    city: "Bronx",
    state: "NY",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "12/09/2026",
    mission: "To prepare students to become knowledgeable, compassionate physicians and innovative scientific investigators, and to create new knowledge. Compassion, collaboration, and collegiality are the hallmarks of an Einstein education.",
    mcat: {
      p10: 513, p25: 516, median: 519, p75: 521, p90: 523
    },
    gpa: {
      p10: null, p25: null, median: 3.93, p75: null, p90: null
    },
    sciGpa: 3.91,
    applicationStats: {
      verifiedApps: { inState: 2065, outOfState: 11330, international: 640, total: 14035 },
      interviewed: { inState: 354, outOfState: 767, international: 0, total: 1121 },
      matriculated: { inState: 70, outOfState: 78, international: 0, total: 148 },
    },
  },
  {
    id: "boston-universityy-aram-v-chobanian-edward-avedisian-school-of-medicine",
    name: "Boston University Chobanian & Avedisian School of Medicine",
    city: "Boston",
    state: "MA",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "01/08/2027",
    secondaryDeadline: "12/09/2026",
    mission: "Dedicated to the educational, intellectual, professional, and personal development of a diverse group of exceptional students who are deeply committed to the study and practice of medicine. A social justice medical school placing great value on excellence, integrity, service, and interdisciplinary collaboration.",
    mcat: {
      p10: 513, p25: 515, median: 519, p75: 521, p90: 524
    },
    gpa: {
      p10: null, p25: null, median: 3.92, p75: null, p90: null
    },
    sciGpa: 3.91,
    applicationStats: {
      verifiedApps: { inState: 954, outOfState: 9685, international: 790, total: 11429 },
      interviewed: { inState: 150, outOfState: 946, international: 13, total: 1109 },
      matriculated: { inState: 43, outOfState: 91, international: 4, total: 138 },
    },
  },
  {
    id: "case-westerrnn-reserve-university-school-of-medicine",
    name: "Case Western Reserve University School of Medicine",
    city: "Cleveland",
    state: "OH",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "11/15/2026",
    mission: "To improve health globally by linking groundbreaking innovation and research directly to patients and populations. Educating future physicians who will care for patients with mastery, creativity, and compassion, in a setting that fosters collegiality, leadership, and excellence in scholarship and research.",
    mcat: {
      p10: 514, p25: 516, median: 518, p75: 520, p90: 523
    },
    gpa: {
      p10: null, p25: null, median: 3.94, p75: null, p90: null
    },
    sciGpa: 3.93,
    applicationStats: {
      verifiedApps: { inState: 779, outOfState: 7931, international: 744, total: 9454 },
      interviewed: { inState: 128, outOfState: 970, international: 13, total: 1111 },
      matriculated: { inState: 32, outOfState: 177, international: 7, total: 216 },
    },
  },
  {
    id: "columbia-university-vagelos-college-of-physicians-and-surgeons",
    name: "Columbia University Vagelos College of Physicians and Surgeons",
    city: "New York",
    state: "NY",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "10/22/2026",
    mission: "We aspire to transform human health by driving discovery, advancing care, and educating leaders. We do this work in service to others and our community, both locally and globally. We strive to educate the next generation of physician leaders who will serve communities through the lens of health equity.",
    mcat: {
      p10: 517, p25: 519, median: 522, p75: 524, p90: 526
    },
    gpa: {
      p10: null, p25: null, median: 3.97, p75: null, p90: null
    },
    sciGpa: 3.97,
    applicationStats: {
      verifiedApps: { inState: 1140, outOfState: 6090, international: 447, total: 7677 },
      interviewed: { inState: 105, outOfState: 618, international: 0, total: 723 },
      matriculated: { inState: 16, outOfState: 122, international: 0, total: 138 },
    },
  },
  {
    id: "donald-and-barbara-zucker-school-of-medicine-at-hofstra-northwell",
    name: "Donald and Barbara Zucker School of Medicine at Hofstra/Northwell",
    city: "Hempstead",
    state: "NY",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "01/08/2027",
    secondaryDeadline: "12/09/2026",
    mission: "In a culture of community, scholarship, and innovation, dedicated to inspiring diverse and promising students to lead and transform medicine for the betterment of humanity.",
    mcat: {
      p10: 514, p25: 516, median: 519, p75: 522, p90: 523
    },
    gpa: {
      p10: null, p25: null, median: 3.93, p75: null, p90: null
    },
    sciGpa: null,
    applicationStats: {
      verifiedApps: { inState: 1627, outOfState: 3725, international: 16, total: 5368 },
      interviewed: { inState: 397, outOfState: 407, international: 0, total: 804 },
      matriculated: { inState: 60, outOfState: 44, international: 0, total: 104 },
    },
  },
  {
    id: "duke-univerrsity-school-of-medicine",
    name: "Duke University School of Medicine",
    city: "Durham",
    state: "NC",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "11/16/2026",
    mission: "A diverse and inclusive community of trainees devoted to understanding the causes, prevention and treatment of human disease. Our objective is to educate physicians with our innovative curricula and broad-based clinical and research training.",
    mcat: {
      p10: 512, p25: 516, median: 520, p75: 522, p90: 524
    },
    gpa: {
      p10: null, p25: null, median: 3.95, p75: null, p90: null
    },
    sciGpa: 3.93,
    applicationStats: {
      verifiedApps: { inState: 697, outOfState: 7960, international: 577, total: 9234 },
      interviewed: { inState: 48, outOfState: 554, international: 40, total: 642 },
      matriculated: { inState: 18, outOfState: 100, international: 5, total: 123 },
    },
  },
  {
    id: "harvard-medical-school",
    name: "Harvard Medical School",
    city: "Boston",
    state: "MA",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "10/22/2026",
    mission: "To nurture a diverse, inclusive community dedicated to alleviating suffering and improving health and well-being for all through excellence in teaching and learning, discovery and scholarship, and service and leadership.",
    mcat: {
      p10: 517, p25: 518, median: 521, p75: 524, p90: 526
    },
    gpa: {
      p10: null, p25: null, median: 3.98, p75: null, p90: null
    },
    sciGpa: 3.98,
    applicationStats: {
      verifiedApps: { inState: 659, outOfState: 7057, international: 559, total: 8275 },
      interviewed: { inState: 79, outOfState: 603, international: 34, total: 716 },
      matriculated: { inState: 24, outOfState: 130, international: 11, total: 165 },
    },
  },
  {
    id: "icahn-school-of-medicine-at-mount-sinai",
    name: "Icahn School of Medicine at Mount Sinai",
    city: "New York",
    state: "NY",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/13/2026",
    secondaryDeadline: "10/14/2026",
    mission: "Advances science, medicine, and health care delivery for the benefit of humanity through a culture of excellence, innovation, collaboration, and belonging. We conduct groundbreaking research; educate and nurture the next generation of exceptional clinicians, researchers, teachers, and leaders; and deliver the most advanced compassionate care with an unwavering commitment to health equity.",
    mcat: {
      p10: 515, p25: 518, median: 520, p75: 522, p90: 524
    },
    gpa: {
      p10: null, p25: null, median: 3.95, p75: null, p90: null
    },
    sciGpa: 3.94,
    applicationStats: {
      verifiedApps: { inState: 1577, outOfState: 7385, international: 589, total: 9551 },
      interviewed: { inState: 191, outOfState: 594, international: 13, total: 798 },
      matriculated: { inState: 34, outOfState: 94, international: 0, total: 128 },
    },
  },
  {
    id: "johns-hopkins-university-school-of-medicine",
    name: "Johns Hopkins University School of Medicine",
    city: "Baltimore",
    state: "MD",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "10/21/2026",
    mission: "To prepare physicians to practice compassionate clinical medicine of the highest standard and to identify and solve fundamental questions in the mechanisms, prevention and treatment of disease, in health care delivery and in the basic sciences.",
    mcat: {
      p10: 517, p25: 519, median: 522, p75: 524, p90: 526
    },
    gpa: {
      p10: null, p25: null, median: 3.97, p75: null, p90: null
    },
    sciGpa: 3.98,
    applicationStats: {
      verifiedApps: { inState: 487, outOfState: 7050, international: 520, total: 8057 },
      interviewed: { inState: 31, outOfState: 494, international: 12, total: 537 },
      matriculated: { inState: 0, outOfState: 108, international: 2, total: 110 },
    },
  },
  {
    id: "keck-school-of-medicine-of-usc",
    name: "Keck School of Medicine of USC",
    city: "Los Angeles",
    state: "CA",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "01/08/2027",
    secondaryDeadline: "10/14/2026",
    mission: "To ignite discovery through education, research and patient care, optimizing health for individuals, our diverse communities and society as a whole.",
    mcat: {
      p10: 511, p25: 514, median: 518, p75: 520, p90: 523
    },
    gpa: {
      p10: null, p25: null, median: 3.91, p75: null, p90: null
    },
    sciGpa: 3.89,
    applicationStats: {
      verifiedApps: { inState: 4794, outOfState: 4401, international: 417, total: 9612 },
      interviewed: { inState: 285, outOfState: 154, international: 0, total: 439 },
      matriculated: { inState: 97, outOfState: 23, international: 0, total: 120 },
    },
  },
  {
    id: "mayo-clinic-alix-school-of-medicine",
    name: "Mayo Clinic Alix School of Medicine",
    city: "Rochester",
    state: "MN",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/13/2026",
    secondaryDeadline: "10/15/2026",
    mission: "Develop a diverse community of servant physician leaders by providing excellence in education, fostering a culture of patient-centered care, and stimulating scientific discovery. We aim to promote health equity and improve clinical care through innovation and collaboration.",
    mcat: {
      p10: 514, p25: 519, median: 521, p75: 523, p90: 525
    },
    gpa: {
      p10: null, p25: null, median: 3.95, p75: null, p90: null
    },
    sciGpa: 3.95,
    applicationStats: {
      verifiedApps: { inState: 314, outOfState: 5393, international: 213, total: 5920 },
      interviewed: { inState: 146, outOfState: 600, international: 10, total: 756 },
      matriculated: { inState: 7, outOfState: 99, international: 3, total: 109 },
    },
  },
  {
    id: "northwestern-university-feinberg-school-of-medicine",
    name: "Northwestern University Feinberg School of Medicine",
    city: "Chicago",
    state: "IL",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "01/08/2027",
    secondaryDeadline: "11/15/2026",
    mission: "To impact the practice of medicine through discovery and education to improve human health. The pursuit of excellence requires a learning organization grounded in leadership, innovation, and compassionate care.",
    mcat: {
      p10: 517, p25: 518, median: 521, p75: 523, p90: 525
    },
    gpa: {
      p10: null, p25: null, median: 3.95, p75: null, p90: null
    },
    sciGpa: 3.94,
    applicationStats: {
      verifiedApps: { inState: 964, outOfState: 7204, international: 442, total: 8610 },
      interviewed: { inState: 87, outOfState: 581, international: 17, total: 685 },
      matriculated: { inState: 36, outOfState: 104, international: 0, total: 140 },
    },
  },
  {
    id: "nyu-grossman-school-of-medicine",
    name: "NYU Grossman School of Medicine",
    city: "New York",
    state: "NY",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "N/A",
    mission: "We strive to recruit and accept the most academically talented and interpersonally gifted student body, one with a collective ability and desire to deliver excellence in clinical care, research, and medical education to all members of society.",
    mcat: {
      p10: 519, p25: 520, median: 523, p75: 525, p90: 526
    },
    gpa: {
      p10: null, p25: null, median: 3.99, p75: null, p90: null
    },
    sciGpa: 4.0,
    applicationStats: {
      verifiedApps: { inState: 1146, outOfState: 6806, international: 433, total: 8385 },
      interviewed: { inState: 81, outOfState: 655, international: 12, total: 748 },
      matriculated: { inState: 21, outOfState: 76, international: 2, total: 99 },
    },
  },
  {
    id: "perelman-school-of-medicine-at-the-university-of-pennsylvania",
    name: "Perelman School of Medicine at the University of Pennsylvania",
    city: "Philadelphia",
    state: "PA",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "11/15/2026",
    mission: "Will select students who are poised and prepared to become future physician leaders in health care. These students will serve their communities and contribute to society through their clinical, educational, research, health policy, and entrepreneurial efforts.",
    mcat: {
      p10: 518, p25: 520, median: 522, p75: 524, p90: 526
    },
    gpa: {
      p10: null, p25: null, median: 3.98, p75: null, p90: null
    },
    sciGpa: 3.98,
    applicationStats: {
      verifiedApps: { inState: 580, outOfState: 5988, international: 529, total: 7097 },
      interviewed: { inState: 66, outOfState: 705, international: 29, total: 800 },
      matriculated: { inState: 17, outOfState: 130, international: 6, total: 153 },
    },
  },
  {
    id: "stanford-university-school-of-medicine",
    name: "Stanford University School of Medicine",
    city: "Stanford",
    state: "CA",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/13/2026",
    secondaryDeadline: "N/A",
    mission: "To inspire and prepare a diverse group of exceptional physician scientists, scholars, and leaders to transform human health across all communities through pioneering research and discovery, innovative education, and compassionate patient-centered healthcare.",
    mcat: {
      p10: 514, p25: 517, median: 520, p75: 523, p90: 525
    },
    gpa: {
      p10: null, p25: null, median: 3.96, p75: null, p90: null
    },
    sciGpa: 3.96,
    applicationStats: {
      verifiedApps: { inState: 3230, outOfState: 5846, international: 717, total: 9793 },
      interviewed: { inState: 134, outOfState: 325, international: 38, total: 497 },
      matriculated: { inState: 36, outOfState: 36, international: 7, total: 79 },
    },
  },
  {
    id: "university-of-arizona-college-of-medicine-phoenix",
    name: "University of Arizona College of Medicine - Phoenix",
    city: "Phoenix",
    state: "AZ",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "11/16/2026",
    secondaryDeadline: "12/09/2026",
    mission: "Inspires and trains exemplary physicians, scientists and leaders to optimize health and health care in Arizona and beyond. Uniquely positioned to accelerate the biomedical and economic engines in Phoenix and the State by leveraging vital relationships with key clinical and community partners.",
    mcat: {
      p10: 507, p25: 514, median: 518, p75: 521, p90: 524
    },
    gpa: {
      p10: null, p25: null, median: 3.94, p75: null, p90: null
    },
    sciGpa: 3.93,
    applicationStats: {
      verifiedApps: { inState: 764, outOfState: 5053, international: 14, total: 5831 },
      interviewed: { inState: 208, outOfState: 271, international: 0, total: 479 },
      matriculated: { inState: 87, outOfState: 43, international: 0, total: 130 },
    },
  },
  {
    id: "university-of-chicago-pritzker-school-of-medicine",
    name: "University of Chicago Pritzker School of Medicine",
    city: "Chicago",
    state: "IL",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "11/16/2026",
    secondaryDeadline: "12/09/2026",
    mission: "Dedicated to inspiring diverse students of exceptional promise to become leaders and innovators in science and medicine for the betterment of humanity. Values service, leadership, and the creation of new knowledge. Seeks applicants whose personal mission within medicine includes health justice and service to underserved communities.",
    mcat: {
      p10: 513, p25: 516, median: 520, p75: 522, p90: 524
    },
    gpa: {
      p10: null, p25: null, median: 3.94, p75: null, p90: null
    },
    sciGpa: 3.94,
    applicationStats: {
      verifiedApps: { inState: 838, outOfState: 6379, international: 521, total: 7738 },
      interviewed: { inState: 76, outOfState: 538, international: 15, total: 629 },
      matriculated: { inState: 17, outOfState: 72, international: 2, total: 91 },
    },
  },
  {
    id: "university-of-michigan-medical-school",
    name: "University of Michigan Medical School",
    city: "Ann Arbor",
    state: "MI",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "09/15/2026",
    secondaryDeadline: "10/15/2026",
    mission: "To transform health through bold and innovative education, discovery and service. Recruit, develop and retain the best faculty, staff and learners who work together for the greater good.",
    mcat: {
      p10: 512, p25: 515, median: 518, p75: 520, p90: 523
    },
    gpa: {
      p10: null, p25: null, median: 3.95, p75: null, p90: null
    },
    sciGpa: 3.88,
    applicationStats: {
      verifiedApps: { inState: 1189, outOfState: 9057, international: 31, total: 10277 },
      interviewed: { inState: 110, outOfState: 333, international: 0, total: 443 },
      matriculated: { inState: 54, outOfState: 114, international: 0, total: 168 },
    },
  },
  {
    id: "university-of-rochester-school-of-medicine-and-dentistry",
    name: "University of Rochester School of Medicine and Dentistry",
    city: "Rochester",
    state: "NY",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "11/15/2026",
    mission: "We improve the health of individuals and populations through an innovative medical education program that emphasizes humility and growth. We inspire learners to become compassionate leaders in medicine and science by emphasizing collaboration, discovery and excellence. Guided by the core principle of Meliora -- Ever Better.",
    mcat: {
      p10: 514, p25: 516, median: 519, p75: 521, p90: 523
    },
    gpa: {
      p10: null, p25: null, median: 3.77, p75: null, p90: null
    },
    sciGpa: 3.93,
    applicationStats: {
      verifiedApps: { inState: 1272, outOfState: 4534, international: 85, total: 5891 },
      interviewed: { inState: 139, outOfState: 470, international: 6, total: 615 },
      matriculated: { inState: 28, outOfState: 74, international: 1, total: 103 },
    },
  },
  {
    id: "university-of-virginia-school-of-medicine",
    name: "University of Virginia School of Medicine",
    city: "Charlottesville",
    state: "VA",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "01/08/2027",
    secondaryDeadline: "11/15/2026",
    mission: "Our mission is to transform health and inspire hope for all Virginians and beyond. Our vision is to be the nation's leading public academic School of Medicine and the best place to work -- while transforming patient care, research, education, and management with the communities we serve.",
    mcat: {
      p10: 514, p25: 518, median: 520, p75: 523, p90: 525
    },
    gpa: {
      p10: null, p25: null, median: 3.96, p75: null, p90: null
    },
    sciGpa: 3.95,
    applicationStats: {
      verifiedApps: { inState: 992, outOfState: 5604, international: 552, total: 7148 },
      interviewed: { inState: 154, outOfState: 512, international: 12, total: 678 },
      matriculated: { inState: 81, outOfState: 73, international: 2, total: 156 },
    },
  },
  {
    id: "usf-health-morsani-college-of-medicine",
    name: "USF Health Morsani College of Medicine",
    city: "Tampa",
    state: "FL",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "01/15/2027",
    secondaryDeadline: "N/A",
    mission: "To provide for the education of students through the creation of a scholarly environment that fosters excellence in the lifelong goals of education, research activity, and compassionate patient care.",
    mcat: {
      p10: 517, p25: 520, median: 521, p75: 523, p90: 524
    },
    gpa: {
      p10: null, p25: null, median: 3.97, p75: null, p90: null
    },
    sciGpa: 3.97,
    applicationStats: {
      verifiedApps: { inState: 2443, outOfState: 3186, international: 48, total: 5677 },
      interviewed: { inState: 458, outOfState: 490, international: 0, total: 948 },
      matriculated: { inState: 67, outOfState: 64, international: 0, total: 131 },
    },
  },
  {
    id: "vanderbilt-university-school-of-medicine",
    name: "Vanderbilt University School of Medicine",
    city: "Nashville",
    state: "TN",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "01/08/2027",
    secondaryDeadline: "11/15/2026",
    mission: "To catalyze the advancement of impactful discovery, servant leadership, and lifelong learning. Core values of integrity, belonging, humility, fairness, mutual respect, and excellence.",
    mcat: {
      p10: 516, p25: 520, median: 522, p75: 524, p90: 525
    },
    gpa: {
      p10: null, p25: null, median: 3.97, p75: null, p90: null
    },
    sciGpa: 3.97,
    applicationStats: {
      verifiedApps: { inState: 376, outOfState: 6808, international: 501, total: 7685 },
      interviewed: { inState: 20, outOfState: 622, international: 26, total: 668 },
      matriculated: { inState: 6, outOfState: 86, international: 3, total: 95 },
    },
  },
  {
    id: "washington-university-in-st-louis-school-of-medicine",
    name: "Washington University in St. Louis School of Medicine",
    city: "Saint Louis",
    state: "MO",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "10/29/2026",
    mission: "In leading the advancement of human health, WashU Medicine will cultivate excellence within an equitable and inclusive community, innovate through discoveries in basic, clinical, translational and population sciences, and apply advances in research and education for the betterment of the human condition, locally and globally.",
    mcat: {
      p10: 515, p25: 518, median: 521, p75: 524, p90: 525
    },
    gpa: {
      p10: null, p25: null, median: 3.96, p75: null, p90: null
    },
    sciGpa: 3.95,
    applicationStats: {
      verifiedApps: { inState: 276, outOfState: 5346, international: 516, total: 6138 },
      interviewed: { inState: 49, outOfState: 952, international: 55, total: 1056 },
      matriculated: { inState: 10, outOfState: 103, international: 10, total: 123 },
    },
  },
  {
    id: "weill-cornell-medicine",
    name: "Weill Cornell Medicine",
    city: "New York",
    state: "NY",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "11/16/2026",
    mission: "Changing medicine through care that puts people first, discoveries that break new ground, and education that shapes the future of science and healthcare. We deliver personalized, compassionate care, conduct pioneering biomedical research, and train the next generation of healthcare leaders.",
    mcat: {
      p10: 517, p25: 513, median: 519, p75: 522, p90: 525
    },
    gpa: {
      p10: null, p25: null, median: 3.94, p75: null, p90: null
    },
    sciGpa: 3.94,
    applicationStats: {
      verifiedApps: { inState: 1393, outOfState: 6685, international: 521, total: 8599 },
      interviewed: { inState: 103, outOfState: 645, international: 29, total: 777 },
      matriculated: { inState: 35, outOfState: 69, international: 2, total: 106 },
    },
  },
  {
    id: "yale-school-of-medicine",
    name: "Yale School of Medicine",
    city: "New Haven",
    state: "CT",
    type: "MD",
    region: "US",
    estimated: false,
    primaryDeadline: "10/15/2026",
    secondaryDeadline: "11/15/2026",
    mission: "Educates and nurtures creative leaders in medicine and science, promoting curiosity and critical inquiry in an inclusive environment enriched by diversity. We advance discovery and innovation fostered by partnerships across the University, our local community, and the world.",
    mcat: {
      p10: 516, p25: 519, median: 522, p75: 525, p90: 526
    },
    gpa: {
      p10: null, p25: null, median: 3.96, p75: null, p90: null
    },
    sciGpa: 3.96,
    applicationStats: {
      verifiedApps: { inState: 266, outOfState: 6541, international: 545, total: 7352 },
      interviewed: { inState: 14, outOfState: 608, international: 25, total: 647 },
      matriculated: { inState: 6, outOfState: 92, international: 6, total: 104 },
    },
  },
];

// US States list for the profile bar dropdown
export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
  'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
  'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC',
];

// ─── Matching Algorithm ───────────────────────────────────────────────────────
// Percentile-based methodology using full MCAT distribution where available.
// MCAT: interpolated against p10/p25/median/p75/p90 bands → 0-100 percentile
// GPA: estimated from median only → percentile = 50 + delta/0.15 * 40
// Both percentiles converted to 0-4 axis scores, then weighted 60/40 MCAT/GPA.
// Adjustments: science GPA tiebreaker, in-state/OOS scaled by enrollment mix.
// Thresholds: >=3.0 safety, >=2.2 match, >=1.3 reach, <1.3 longshot.

function mcatPercentile(score, dist) {
  var p10 = dist.p10, p25 = dist.p25, median = dist.median, p75 = dist.p75, p90 = dist.p90;
  if (score >= p90) return Math.min(100, 90 + Math.min(10, (score - p90) * 3));
  if (score >= p75) return 75 + (score - p75) / (p90 - p75) * 15;
  if (score >= median) return 50 + (score - median) / (p75 - median) * 25;
  if (score >= p25) return 25 + (score - p25) / (median - p25) * 25;
  if (score >= p10) return 10 + (score - p10) / (p25 - p10) * 15;
  return Math.max(0, 10 - (p10 - score) * 3);
}

function gpaPercentile(studentGpa, schoolMedian) {
  return Math.min(100, Math.max(0, 50 + (studentGpa - schoolMedian) / 0.15 * 40));
}

function percentileToAxisScore(pct) {
  if (pct >= 75) return 3.5 + Math.min(0.5, (pct - 75) / 25 * 0.5);
  if (pct >= 50) return 2.5 + (pct - 50) / 25;
  if (pct >= 25) return 1.5 + (pct - 25) / 25;
  if (pct >= 10) return 0.5 + (pct - 10) / 15;
  return pct / 10 * 0.5;
}

export function matchSchools(params) {
  var mcat = Number(params.mcat);
  var gpa = Number(params.gpa);
  var sciGpa = params.sciGpa != null ? Number(params.sciGpa) : null;
  var state = params.state;
  var degreeTypes = params.degreeTypes || ['MD'];
  var regions = params.regions || ['US'];

  return medicalSchools
    .filter(function(s) {
      return degreeTypes.includes(s.type) && regions.includes(s.region);
    })
    .map(function(s) {
      if (!s.mcat || !s.mcat.median || !s.mcat.p10 || !s.mcat.p25 || !s.mcat.p75 || !s.mcat.p90 || !s.gpa || !s.gpa.median) {
        return Object.assign({}, s, { category: 'longshot', finalScore: 0, mcatPercentile: null, gpaPercentile: null });
      }

      // Steps 1-2: percentile placement
      var mcatPct = mcatPercentile(mcat, s.mcat);
      var gpaPct = gpaPercentile(gpa, s.gpa.median);

      // Step 3: axis scores
      var mcatScore = percentileToAxisScore(mcatPct);
      var gpaScore = percentileToAxisScore(gpaPct);

      // Step 4: weighted combination
      var combined = mcatScore * 0.60 + gpaScore * 0.40;

      // Step 5: science GPA tiebreaker
      if (s.sciGpa && sciGpa !== null) {
        var sciDelta = sciGpa - s.sciGpa;
        if (sciDelta >= 0.05) combined += 0.12;
        else if (sciDelta <= -0.10) combined -= 0.12;
      }

      // Step 6: in-state / OOS adjustment scaled by enrollment mix
      var stats = s.applicationStats;
      var totalMat = stats && stats.matriculated && stats.matriculated.total;
      var inStateMat = stats && stats.matriculated && stats.matriculated.inState;
      var inStatePct = (totalMat && inStateMat) ? inStateMat / totalMat : null;
      var isInState = s.state === state;

      if (isInState && inStatePct !== null) {
        if (inStatePct >= 0.50) combined += 0.35;
        else if (inStatePct >= 0.30) combined += 0.20;
        else combined += 0.08;
      } else if (!isInState && inStatePct !== null) {
        if (inStatePct >= 0.60) combined -= 0.35;
        else if (inStatePct >= 0.40) combined -= 0.15;
        // <40% in-state: no penalty
      }

      // Step 7: category thresholds
      var category;
      if (combined >= 3.0) category = 'safety';
      else if (combined >= 2.2) category = 'match';
      else if (combined >= 1.3) category = 'reach';
      else category = 'longshot';

      return Object.assign({}, s, {
        category: category,
        finalScore: combined,
        mcatPercentile: Math.round(mcatPct),
        gpaPercentile: Math.round(gpaPct),
      });
    })
    .sort(function(a, b) {
      var order = { safety: 0, match: 1, reach: 2, longshot: 3 };
      return (order[a.category] || 0) - (order[b.category] || 0);
    });
}

// Keep medicalSchools accessible as named export alias for SchoolDetail
export { medicalSchools as default };
